import React, {Component} from 'react'
import {Button, Modal} from 'semantic-ui-react'

export default class UnknownPlayerModal extends Component {

    state = {};

    handleClick = (ev, data) => this.setState({chosenPlayer: data.player});

    handleSubmit = () => this.props.setCurrentAgent(this.state.chosenPlayer);

    render() {
        const playerOptions = this.props.players
            .filter(p => !p.authenticated)
            .map(player =>
                <Button
                    key={player.id}
                    onClick={this.handleClick}
                    player={player}
                    inverted color='red'
                    content={player.name}/>);

        return (
            <Modal
                open={this.props.open}
                basic
                size='small'
                closeOnEscape={false}
                closeOnDimmerClick={false}
            >
                <Modal.Header icon='users' content='Hvem er du?'/>
                <Modal.Content>
                    {playerOptions}
                    <Button onClick={this.handleClick} player={{ name: 'Gjest', id: 'guest' }} inverted content='Gjest'/>
                </Modal.Content>
                {this.state.chosenPlayer ?
                    <Modal.Actions>
                        Du er {this.state.chosenPlayer.name}?
                        {<Button inverted onClick={this.handleSubmit} color='green' content='Stemmer'/>}
                    </Modal.Actions>
                    : <Modal.Actions>
                        Hvem er du?
                    </Modal.Actions>}
            </Modal>)
    }
}



// WEBPACK FOOTER //
// ./src/Components/UnknownPlayerModal.js